module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Southampton-bccc80688c353f17ea645cc68f2ecafd.svg";